import i18next from "i18next";
import moment from "moment";

export const filesColumns = (t: any) => [
    {
      key: "column1",
      name: t("nav.fileName"),
      fieldName: "originalFileName",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column1_2",
      name: t("nav.description"),
      fieldName: "description",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column2",
      name: t("nav.documentType"),
      fieldName: "documentTypeStr",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column3",
      name: t("clients.columns.containersNumber"),
      fieldName: "containersNumber",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
        key: "column4",
        name: t("nav.documentDate"),
        fieldName: "documentDate",
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
      },
  ];

  export const generateFilesList = (filesDetails: Array<any>) => {
    const items: Array<any> = [];
    filesDetails.forEach((filesDetail: any) => {
      items.push({
        key: filesDetail.id,
        id: filesDetail.id,
        blobFileName: filesDetail.blobFileName,
        documentType: filesDetail.documentType,
        documentTypeStr: ParseDocumentType(filesDetail.documentType),
        containersNumber: filesDetail.containersNumber,
        documentDate: moment(filesDetail.documentDate).format('MM.DD.YYYY'),
        fileUrl: filesDetail.fileUrl,
        originalFileName: filesDetail.originalFileName,
        description: filesDetail.description
      })
    });

    return [...items];
  };

  export const ParseDocumentType = (documentType: number) =>{
    switch(documentType){
      case 1:
        return i18next.t("nav.fileTypeContract", { ns: "admin" });
      case 2:
        return i18next.t("nav.fileTypeAcceptanceReport", { ns: "admin" });
      case 3:
        return i18next.t("nav.fileTypeHandoverProtocol", { ns: "admin" });
    }
  }